import React, { Component } from "react";
import { connect } from "react-redux";
import RupeeIcon from "../../images/rupee.svg";
import downloadIcon from "../../images/download.svg";
import * as actions from "../../containers/payout/actions";
import "../../containers/payout/styles.css";
import { opdbGTM } from "../../utils/pulseUtils";

class CumulativePayout extends Component {
  onDownloadIconClick() {
    const { startDate, endDate } = this.props;
    let query = {
      settled_after: startDate,
      settled_before: endDate,
    };
    this.props.getCumulativePayoutList(query);
    opdbGTM.cumulativeDownloadClicked(startDate, endDate)
  }
  onDownloadPdfClick = () => {
    const { startDate, endDate } = this.props;
    let query = {
      settled_after: startDate,
      settled_before: endDate,
    };
    this.props.getCumulativePayoutListPDF(query);
  }
  render() {
    const { cumulativeData, startDate, endDate, amountFormatting } = this.props;
    return (
      <div>
        <div className="table-heading">Cumulative Report</div>
        <table className="app-table">
          <thead>
            <tr className="payout-table-header">
              <th>No</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Booked Seats</th>
              <th>Amount</th>
              <th>Commission</th>
              <th>Cancelled Seats</th>
              <th>Cancelled Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr className="payout-table-row">
              <td>1</td>
              <td>{startDate}</td>
              <td>{endDate}</td>
              <td>{cumulativeData && cumulativeData.totalBooked}</td>
              <td>
                <img className="rupee-icon" alt="Rupee-Icon" src={RupeeIcon} />{" "}
                {amountFormatting(cumulativeData && cumulativeData.totalAmount)}
              </td>
              <td>
                <img className="rupee-icon" alt="Rupee-Icon" src={RupeeIcon} />{" "}
                {amountFormatting(cumulativeData && cumulativeData.totalCommission)}
              </td>
              <td>{cumulativeData && cumulativeData.totalCancelledSeats}</td>
              <td>
                <img className="rupee-icon" alt="Rupee-Icon" src={RupeeIcon} />{" "}
                {amountFormatting(cumulativeData && cumulativeData.totalCancelledAmount)}
              </td>
              <td>
                <div className="actions-container">
                <div
                  className="download-button"
                  onClick={() => this.onDownloadIconClick()}
                >
                  <img src={downloadIcon} alt="download-icon" />
                  <span className="download-text">CSV</span>
                </div>
                <div
                  className="download-button"
                  onClick={() => this.onDownloadPdfClick()}
                >
                  <img src={downloadIcon} alt="download-icon" />
                  <span className="download-text">PDF</span>
                </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  getCumulativePayoutList: (query) =>
    dispatch(actions.getCumulativePayoutList(query)),
    getCumulativePayoutListPDF: (query) =>
    dispatch(actions.getCumulativePayoutListPDF(query))
});

export default connect(null, mapDispatchToProps)(CumulativePayout);
